import React, { useEffect } from "react";
import {
  Document,
  Image,
  Page,
  PDFViewer,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { Colors } from "../../../assets/Colors";
import { useParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { fetchGet } from "../../../fetchers";
import LOGO_RKS from "../../../assets/logo/LOGO_RKS.png";
import angkaTerbilang from "@develoka/angka-terbilang-js"; // if using import
const PAGE_HEIGHT = 822; // Change this to your desired page height
const MARGIN = 15; // Adjust as needed

const ROWS_PER_PAGE = Math.floor((PAGE_HEIGHT - 2 * MARGIN) / 20); // Assuming each row is 20 units in height

// Create styles
const styles = StyleSheet.create({
  page: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  pageBreak: {
    width: "100%",
    height: 0, // Add spacing between pages if needed
    pageBreakAfter: "always",
  },

  title: {
    fontSize: 14,
    fontWeight: "bold",
  },
  viewHeader: {
    width: 130,

    marginLeft: 200,
  },
  title_sub: {
    fontWeight: "bold",
    fontSize: 12,
    textAlign: "center",
  },
  header_kepada: {
    fontWeight: "bold",
    fontSize: 12,
  },
  bottom_ttd: {
    marginTop: 20,
    fontWeight: "bold",
    fontSize: 10,
    width: 200,
  },
  bottom_paraf: {
    marginTop: 100,
    fontWeight: "bold",
    fontSize: 12,
    width: 30,
  },

  header_namasupp: {
    fontWeight: "bold",
    fontSize: 12,
    textTransform: "capitalize",
  },
  title_border: {
    borderBottom: 1,
    fontSize: 12,
    textAlign: "center",
  },
  Stitle_border: {
    fontSize: 10,
    textAlign: "center",
    marginBottom: 20,
  },

  header_section: {
    flexDirection: "row",
  },
  header_section_ttd: {
    marginTop: 20,
    pageBreakInside: "avoid",
    flexDirection: "row",
    breakeInside: "avoid",
  },

  header_title: {
    width: 210,
    fontSize: 9,
    textAlign: "justify",
  },
  header_title_satu: {
    width: 173,
    fontSize: 10,
    marginLeft: 5,
    textAlign: "justify",
  },
  header_paraf: {
    width: 30,
    fontSize: 9,
    left: 0,
  },

  header_Right: {
    width: 120,
    marginLeft: 70,
    fontSize: 9,
    textAlign: "left",
  },
  header_Right_satu: {
    width: 120,
    marginLeft: 129,
    fontSize: 10,
    textAlign: "left",
  },
  header_Left: {
    width: 135,
    fontSize: 9,
    marginLeft: 5,
    textAlign: "left",
  },
  header_Rightv: {
    width: 70,
    marginLeft: 133,
    fontSize: 9,
    textAlign: "left",
  },
  header_mark: {
    width: 15,
    fontSize: 9,
    textAlign: "justify",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  text: {
    fontSize: 9,
    textAlign: "justify",
    width: 100
  },

  table: {
    borderLeftWidth: 1,
    // borderRadius: 5,
    borderStyle: "solid",
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
  },
  cell: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 0,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderStyle: "solid",
    fontSize: 10,
  },
  cellSecondary: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 0,
    borderTop: 0,
    borderLeftWidth: 0,
    borderStyle: "solid",
    fontSize: 10,
  },
  cellClosing: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 1,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderStyle: "solid",
    fontSize: 10,
  },
  paddings: {
    paddingTop: 10,
  },
  logo: {
    width: 200,
    marginBottom: 20,
    marginLeft: 325,
  },
  logottd: {
    height: 50,
    fontWeight: "bold",
    fontSize: 9,
    width: 90,
  },
  stamp: {
    height: 60,
    fontWeight: "bold",
    fontSize: 9,
    width: 60,
    position: "absolute",
    top: 53,
    left: -25,
    zIndex: -1,
  },
  paraf: {
    height: 30,
    fontWeight: "bold",
    fontSize: 9,
    marginLeft: 100,
    width: 30,
  },
});


const SlipGajiReturn = (props) => {
    const data = props.data.data;
    let GajiBersih = 0

    let BPJSTK = parseFloat(Math.floor(data.UpahPokok * 3 /100)).toLocaleString("in-ID", {maximumFractionDigits: 2,})
    let BPJSKS = parseFloat(Math.floor(data.UpahPokok * 1 /100)).toLocaleString("in-ID", {maximumFractionDigits: 2,})
    let UpahPokok = parseFloat(data.UpahPokok).toLocaleString("in-ID", {maximumFractionDigits: 2,})
    let LemburTotal = parseFloat(Math.floor(data.JamLembur *(data.UpahPokok / 173))).toLocaleString("in-ID", {maximumFractionDigits: 2,})
    let UangMakan = parseFloat(data.HariLemburMakan * data.TLemburMakan).toLocaleString("in-ID", {maximumFractionDigits: 2,})
    let JmlPotongan = parseFloat(Math.floor(data.UpahPokok * 3 /100) + Math.floor(data.UpahPokok * 1 /100)).toLocaleString("in-ID", {maximumFractionDigits: 2,})
    
    if (data.GajiBersih == "") {
      GajiBersih = parseFloat(Math.round(
          (Math.floor(
            data.UpahPokok +
              data.JamLembur *
                (data.UpahPokok / 173)
          ) -
            Math.floor(
              data.UpahPokok *
              3 /
              100
            ) -
            Math.floor(
              data.UpahPokok *
              1 /
              100
            ) + 
            (data.HariLemburMakan *
            data.TLemburMakan) 
            + 
            (data.HariKerja * data.THarian)) /
            1000
        ) * 1000).toLocaleString("in-ID", {maximumFractionDigits: 2,})
      
    }else{
      GajiBersih = data.GajiBersih
    }
    return (
    <Document>
      <Page size="A5" style={styles.page} wrap orientation="landscape">
        {/* <Image style={styles.logo} src={LOGO_RKS} /> */}
        <View style={styles.viewHeader}>
          <Text style={styles.title_border}>SLIP GAJI</Text>
        </View>
        <View>
          <Text style={styles.Stitle_border}>{data.Date}</Text>
        </View>

        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{"Nama Karyawan"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{data.NamaKaryawan}
          </Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{"NIK"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{data.NIK}
          </Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{"Department"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{data.Bagian}
          </Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{"Jabatan"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{data.NamaJabatan}
          </Text>
        </View>
        <Text style={styles.text}>{"  __________________________________________________"}</Text>
        <Text style={styles.text}>{" "}</Text>
        <View style={styles.header_section}>
          <Text style={[styles.header_Left, styles.header_kepada]}>{"Gaji Pokok"}</Text>
          <Text style={[styles.header_mark,styles.header_kepada]}>:</Text>
          <Text style={[styles.text, styles.header_kepada]}>{UpahPokok}
          </Text>
        </View>
        
        <Text style={styles.text}>{" "}</Text>
        <View style={styles.header_section}>
        <Text style={styles.header_title_satu}>{"Tambahan"}</Text>
        <Text style={styles.header_Right_satu}>{"Potongan"}</Text>
        </View>
        
        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{"Lembur"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{LemburTotal}
          </Text>
          <Text style={styles.header_Right}>{"BPJS Ketenagakerjaan"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{BPJSTK}
          </Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{"Extra Makan Lembur"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{UangMakan}</Text>
          <Text style={styles.header_Right}>{"BPJS Kesehatan"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{BPJSKS}</Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{"Insentif price increase"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}> </Text>
          <Text style={styles.header_Right}>{"Kelebihan Gaji Bln Lalu"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}> </Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{"Insentif Pengabdian"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}> </Text>
          <Text style={styles.header_Right}>{" "}</Text>
          <Text style={styles.header_mark}>{" "}</Text>
          <Text style={styles.text}>{" "}</Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{"Kekurangan gaji bln lalu"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}> </Text>
          <Text style={[styles.header_Right, styles.header_kepada]}>{"Jumlah Potongan"}</Text>
          <Text style={[styles.header_mark,styles.header_kepada]}>:</Text>
          <Text style={[styles.text, styles.header_kepada]}>{JmlPotongan}
          </Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{" "}</Text>
          <Text style={styles.header_mark}>{" "}</Text>
          <Text style={styles.text}>{" "}</Text>
          <Text style={[styles.header_Right, styles.header_kepada]}>{"Gaji Bersih"}</Text>
          <Text style={[styles.header_mark,styles.header_kepada]}>:</Text>
          <Text style={[styles.text, styles.header_kepada]}>{GajiBersih}
          </Text>
        </View>
        <View style={styles.header_title}>
            <Text style={styles.bottom_ttd}>{"Disetujui Oleh"}</Text>

            {/* <Image
            style={styles.logottd}
            src={"/speciment/ArisSugiyanto.png"}
            /> */}
            {/* <Image
            style={styles.logottd}
            src={""}
            /> */}
            <Text style={styles.bottom_ttd_name}>{"Manager HRGA"}</Text>
        </View>
      </Page>
    </Document>
  );
};

const SlipGaji = () => {
  const params = useParams();
  const mutationGetBlanko = useMutation((form) =>
    fetchGet("getSlipGaji/" + form.date + "/" + form.id)
  );

  useEffect(() => {
    if (params.id && params.date) {
        mutationGetBlanko.mutate({date: params.date, id: params.id});
    }
  }, []);

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-screen -mt-32">
        {mutationGetBlanko.data && (
          <PDFViewer className={"h-screen w-full"}>
            {<SlipGajiReturn data={mutationGetBlanko.data} />}
          </PDFViewer>
        )}
      </div>
    </div>
  );
};
export default SlipGaji;
